import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/pamm',
            name: 'pamm',
            component: () => import("./views/pamm.vue"),
            meta: {
                hasBar: false
            }
        }
    ];
};